import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { eChienDichActionTypeIds } from '../../action-types/crm-survey/IChienDichActionTypes';
import { actions } from '../../actions/actionsWrapper';
import { IChienDichActionTypes } from './../../action-types/crm-survey/IChienDichActionTypes';

import { IDmChienDich } from '../../../models/response/crm-survey/IDmChienDich';


export function* chienDichSaga(): any {
    yield takeLatest(eChienDichActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eChienDichActionTypeIds.LOAD_COSO_START, loadCosoWorker)
    yield takeLatest(eChienDichActionTypeIds.LOAD_TRUONG_START, loadTruongWorker)
    yield takeEvery(eChienDichActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eChienDichActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eChienDichActionTypeIds.LOCK_START, lockWorker)
    yield takeEvery(eChienDichActionTypeIds.UNLOCK_START, unlockWorker)

}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.crmSurveyForm.chienDich.load)
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.chienDich.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.crmSurveyFormWrapper.chienDich.LOAD_ERROR(res.message ?? "Error"))
    }
}
function* loadCosoWorker(action: IChienDichActionTypes): any {
    const payload: number = action.payload as number;

    const res: IBaseResponeModel = yield call([apiWrapper.crmSurveyForm.chienDich, apiWrapper.crmSurveyForm.chienDich.load_by_coso], payload)
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.chienDich.LOAD_COSO_SUCCESS(res.data))
    } else {
        yield put(actions.crmSurveyFormWrapper.chienDich.LOAD_COSO_ERROR(res.message ?? "Error"))
    }
}
function* loadTruongWorker(action: IChienDichActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call([apiWrapper.crmSurveyForm.chienDich, apiWrapper.crmSurveyForm.chienDich.load_truong_by_chiendich], payload)
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.chienDich.LOAD_TRUONG_SUCCESS(res.data))
    } else {
        yield put(actions.crmSurveyFormWrapper.chienDich.LOAD_TRUONG_ERROR(res.message ?? "Error"))
    }
}
function* saveWorker(action: IChienDichActionTypes): any {
    const payload: IDmChienDich = action.payload as IDmChienDich;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.crmSurveyForm.chienDich.update, payload)
    } else {
        res = yield call(apiWrapper.crmSurveyForm.chienDich.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.chienDich.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.crmSurveyFormWrapper.chienDich.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IChienDichActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmSurveyForm.chienDich.delete, payload)
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.chienDich.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.crmSurveyFormWrapper.chienDich.DELETE_ERROR(res.message ?? "Error"))
    }
}
function* lockWorker(action: IChienDichActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmSurveyForm.chienDich.lock, payload)
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.chienDich.LOCK_SUCESS(undefined))
    } else {
        yield put(actions.crmSurveyFormWrapper.chienDich.LOCK_ERROR(res.message ?? "Error"))
    }
}
function* unlockWorker(action: IChienDichActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmSurveyForm.chienDich.unlock, payload)
    if (res.is_success) {
        yield put(actions.crmSurveyFormWrapper.chienDich.UNLOCK_SUCESS(undefined))
    } else {
        yield put(actions.crmSurveyFormWrapper.chienDich.UNLOCK_ERROR(res.message ?? "Error"))
    }
}
